/**
 * Labstep
 *
 * @module screens/Authentication/Component
 * @desc Common component for authentication screen
 */

import { UserLoginContainer } from 'labstep-web/containers/User/Login';
import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import type {
  IAuthenticationComponentContainerProps,
  IAuthenticationComponentProps,
} from './types';

export const AuthenticationComponent: RFC<
  IAuthenticationComponentProps
> = ({ url, children, clearLoginError }) => {
  useEffect(() => {
    clearLoginError();
  }, [url]);
  return <>{children}</>;
};

export const AuthenticationComponentContainer: RFC<
  IAuthenticationComponentContainerProps
> = ({ match, children }) => (
  <UserLoginContainer>
    {({ clearLoginError }) => (
      <AuthenticationComponent
        url={match.url}
        clearLoginError={clearLoginError}
        children={children}
      />
    )}
  </UserLoginContainer>
);

export default withRouter(AuthenticationComponentContainer);
